module.exports = new __parcel__URL__("bladevortexcancel.bdddafbb.png").toString();